import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    rptgl(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['kodeaw', 'kodeak', 'tgl1', 'tgl2', 'noDim', 'excludekosong'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/gl/rptgl${str}`;
                const {data}= await axios.get(url);
                // console.log('data.tb : ', data[1]);
                resolve(data[0]);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    rptglprint(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['kodeaw', 'kodeak', 'tgl1', 'tgl2', 'noDim','excludekosong'];
                let str = '?';
                if (obj.tabIndex === 0) {
                    str += 'view=' + encodeURIComponent('noDim');
                } else {
                    str += 'view=' + encodeURIComponent('noDim');
                }
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                const url = `/gl/rptglprint${str}`;
                const { data } = await axios.get(url);
                // console.log('data : ', data);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });

    },
    rptglexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['kodeaw', 'kodeak', 'tgl1', 'tgl2', 'noDim','excludekosong'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                let response = await axios({
                    url: `/gl/rptglexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(response);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });
    }
};